<template>
  <v-container fluid>
    <alert-error :error="error" />

    <v-sheet tile>
      <request-vacations-list
        :meta="meta"
        :type="type"
        :request-vacations="requestVacations"
        :options.sync="options"
        @show="show"
      />

      <v-dialog v-if="dialog" v-model="dialog" persistent max-width="1200">
        <edit-request-vacation
          :data="component.data"
          @cancel="cancelDialog"
          @updated="cancelDialogAndRefresh"
        />
      </v-dialog>
    </v-sheet>
  </v-container>
</template>

<script>
import DataOptions from '@/modules/_global/classes/DataOptions';
import { debounce } from 'lodash';
import RequestVacationsList from '@/modules/request_vacations/components/RequestVacationsList.vue';
import EditRequestVacation from '@/modules/request_vacations/components/EditRequestVacation.vue';
import { RequestVacationsService } from '@/services/request-vacations.service';
import { PERSON } from '@/modules/request_vacations/components/RequestVacationsList.vue';

const DEBOUNCE_DELAY = 300;

export default {
  name: 'EmployeeVacationRequests',

  components: {
    EditRequestVacation,
    RequestVacationsList,

    AlertError: () => import('@/modules/_global/_components/AlertError')
  },

  props: {
    employeeId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      error: null,
      requestVacations: [],
      meta: {
        total: 0
      },
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['created_at'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      type: PERSON,
      filters: {},
      dialog: false,
      component: null
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    },

    params() {
      return Object.assign(
        {},
        { paginationOptions: this.preparedOptions },
        { filters: this.filters }
      );
    }
  },

  watch: {
    employeeId: {
      handler() {
        this.refreshData();
      },
      immediate: true,
      deep: true
    },
    options: {
      handler() {
        this.refreshData();
      },
      deep: true
    }
  },

  methods: {
    getRequestVacationsData: debounce(function debouncedGetRequestVacations() {
      RequestVacationsService.getList({
        employee: [this.employeeId],
        ...this.params.filters,
        ...this.params.paginationOptions
      })
        .then(({ data: { meta, data } }) => {
          this.meta = meta;
          this.requestVacations = data;
        })
        .catch(error => {
          this.error = error;
        });
    }, DEBOUNCE_DELAY),

    refreshData() {
      this.getRequestVacationsData();
    },

    show(item) {
      this.dialog = true;

      this.component = {
        name: 'EditRequest',
        data: item
      };
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.refreshData();
      this.$emit('updated');
    }
  }
};
</script>
